import { createActions } from "reduxsauce";

export default createActions(
  {
    unexpectedError: ["exception"]
  },
  { prefix: "root/" }
);



// WEBPACK FOOTER //
// ./src/modules/root/root-actions.js